/** A stored answer as plain text: its citation numbers and Markdown markup removed, for showing as a quote. */
export function plainAnswer(text: string): string {
  return text
    .replace(/\s*\[\d+\]/g, '')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^\s*[-*]\s+/gm, '• ')
    .replace(/\*\*(.+?)\*\*/gs, '$1')
    .replace(/\*(\S(?:.*?\S)?)\*/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .trim();
}
